<template>
    <v-container class="fill-height" style="display: block;" fluid>
        <v-window v-model="windowPage" style="width: 100%;" touchless>
            <v-window-item :key="0">
                <template v-if="showSitesList">
                    <sites-list ref="sitesList" :sitesList="sitesList" :siteResources="siteResources" :lockSave="lockSave" :savedSiteIndex="savedSiteIndex" :gridModifications="gridModifications" @edit="editSite" @delete="deleteSiteClick"></sites-list>
                    <v-btn color="#c42111" class="mt-3 mr-3" @click="addNewSite" :disabled="lockSave">New</v-btn>
                    <v-btn color="#c42111" class="mt-3 mr-1" @click="showSitesImporter = true" :disabled="lockSave || !isCustomerAdmin">Sites Importer</v-btn>
                    <v-btn color="#c42111" class="mt-3" @click="showSectorsImporter = true" :disabled="lockSave || !isCustomerAdmin">Sectors Importer</v-btn>
                    <div class="admin-page-grid-center-buttons-container">
                        <div class="admin-page-grid-center-buttons-container-label">
                            <span>Grid Display</span>
                        </div>
                        <v-tooltip top color="rgba(97, 97, 97, 1.0)">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mr-3" fab dark x-small color="#c42111" @click="$refs.sitesList.saveGridModifications" title="Save Grid Modifications" v-on="on">
                                    <v-icon>mdi-content-save</v-icon>
                                </v-btn>
                            </template>
                            <span>Save Grid Modifications</span>
                        </v-tooltip>
                        <v-tooltip top color="rgba(97, 97, 97, 1.0)">
                            <template v-slot:activator="{ on }">
                                <v-btn class="" fab dark x-small color="#c42111" @click="$refs.sitesList.clearGridModifications" title="Clear Grid Modifications" v-on="on">
                                    <v-icon>mdi-layers-remove</v-icon>
                                </v-btn>
                            </template>
                            <span>Clear Grid Modifications</span>
                        </v-tooltip>
                    </div>
                </template>
            </v-window-item>

            <v-window-item :key="1">
                <sites-edit v-if="windowPage == 1" :site="selectedSite" :siteResources="siteResources" :lockSave="lockSave"  @save="saveSite" @cancel="windowPage = 0"></sites-edit>
            </v-window-item>
        </v-window>

        <v-dialog v-model="showSitesImporter" max-width="80%" width="550px" persistent v-if="showSitesImporter">
            <sites-importer @cancel="showSitesImporter = false" @finished="importerFinished" />
        </v-dialog>

        <v-dialog v-model="showSectorsImporter" max-width="80%" width="550px" persistent v-if="showSectorsImporter">
            <sectors-importer @cancel="showSectorsImporter = false" @finished="importerFinished" />
        </v-dialog>
    </v-container>
</template>

<script>
import SitesList from "@/components/Sites/SitesList";
import SitesEdit from "@/components/Sites/SitesEdit";
import SitesImporter from "@/components/Sites/SitesImporter";
import SectorsImporter from "@/components/Sites/SectorsImporter";
export default {
    name: 'Sites',
    props: [''],
    components: {
        SitesList,
        SitesEdit,
        SitesImporter,
        SectorsImporter
    },
    data: () => ({
        windowPage: 0,
        lockSave: false,
        sitesList: [],
        showSitesList: false,
        savedSiteIndex: null,
        selectedSite: null,
        siteResources: [],
        showSitesImporter: false,
        showSectorsImporter: false,
        gridModifications: null
    }),

    computed: {
        isCustomerAdmin: function() {
            return (this.$store.state.user.user_data.is_customer_admin);
        }
    },

    methods: {
        getSitesList: function() {
            this.showSitesList = false;
            let route = (TELSA.apiHost + "sites/list");
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.siteResources = result;
                this.sitesList = result.sites;
            });
        },

        editSite: function(siteId) {
            let route = `${TELSA.apiHost}sites/site/${siteId}`;
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.selectedSite = result.site;
                if(this.selectedSite.sitebook) {
                    this.selectedSite.sitebook.dataRepoStructure = null;
                }
                this.windowPage = 1;
                TELSA.loading(false);
            });
        },

        deleteSiteClick: function(site) {
            this.$store.commit('showConfirmModal', {
                title: 'Delete Site',
                message: `Deleting a site may cause a loss of all historical performance data for this site. Are you sure you want to delete this site?`,
                type: 'delete',
                hideCancel: false,
                confirmAction: () => this.deleteSite(site)
            });
        },

        deleteSite: function(site) {
            let route = `${TELSA.apiHost}sites/delete`;
            TELSA.loading(true);
            return this.$http.post(route, {args: {lock: this.$store.getters.localLock('edit_site'), site: site}}).then(response => {
                let result = response.body;
                Promise.all(this.getPageData()).then(r => {TELSA.loading(false); this.showSitesList = true;});
            });
        },

        addNewSite: function() {
            this.selectedSite = {
                site_id: 0,
                sectors: [],
                site_alias: -1,
                site_groups: [],
                site_lat: -1000,
                site_lat2: -1000,
                site_locale: "",
                site_location: "",
                maint_start: "24:00:00",
                maint_end: "00:00:00",
                site_long: -1000,
                site_long2: -1000,
                site_maps: [],
                site_name: "",
                site_office: "",
                tp_id: -1,
                tree_id: -1,
                user_id: -1,
                network_category_id: null
            };
            this.windowPage = 1;
        },

        saveSite: function(site) {
            let route = `${TELSA.apiHost}sites/edit`;
            if(site.site_id == 0) {
                route = `${TELSA.apiHost}sites/add`;
            }
            TELSA.loading(true);
            return this.$http.post(route, {args: {lock: this.$store.getters.localLock('edit_site'), site: site}}).then(response => {
                let result = response.body;
                this.$store.commit('setIsDirty', false);
                this.windowPage = 0;
                this.savedSiteIndex = this.sitesList.findIndex(s => s.site_id == site.site_id);
                Promise.all(this.getPageData()).then(r => {TELSA.loading(false); this.showSitesList = true;});
            });
        },

        importerFinished: function() {
            this.showSitesImporter = false;
            this.showSectorsImporter = false;
            Promise.all(this.getPageData()).then(r => {TELSA.loading(false); this.showSitesList = true;});
        },

        getGridModifications: function () {
            return this.$store.dispatch('getConfigItem', {key: 'sites_grid_state'}).then(response => {
                let result = response.body; 
                this.gridModifications = result ? JSON.parse(result) : null;
            });
        },

        getPageData: function() {
            let promises = [];
            promises.push(this.getSitesList());
            promises.push(this.getGridModifications());
            return promises;
        }
    },

    mounted() {
        // Permissions Check
        let permission = TELSA.checkPermission(this.$store.state.user, 'admin/sites');
        let sitebookPermission = TELSA.checkPermission(this.$store.state.user, 'admin/sitebook');
        if(!permission || !sitebookPermission) {
            let self = this;
            this.$store.commit('insufficientPermissions', {
                confirmAction: function(){Promise.all(self.getPageData()).then(r => {self.showSitesList = true; TELSA.loading(false);})}
            });
            this.lockSave = true;
            return;
        }

        let promises = [];
        let editSiteLockOwner, editSitebookLockOwner = null;
        promises.push(this.$store.dispatch('getLock', 'edit_site').then(lockOwner => {editSiteLockOwner = lockOwner}));
        promises.push(this.$store.dispatch('getLock', 'edit_sitebook').then(lockOwner => {editSitebookLockOwner = lockOwner}));
        promises = promises.concat(this.getPageData());
        Promise.all(promises).then(v => {
            this.showSitesList = true;
            TELSA.loading(false);

            if(editSiteLockOwner) {
                // Disable save and let user know page is locked!
                this.lockSave = true;
                this.$store.commit('showConfirmModal', {
                    title: 'Lock Warning',
                    message: `The sites list is already locked for editing by <font color="#FB8C00"><b>${editSiteLockOwner}</b></font>. You cannot save any changes at this time.`,
                    type: 'warning',
                    hideCancel: true,
                    confirmAction: function(){}
                });
            }
            else if(editSitebookLockOwner) {
                // Disable save and let user know page is locked!
                this.lockSave = true;
                this.$store.commit('showConfirmModal', {
                    title: 'Lock Warning',
                    message: `The Site Book is already locked for editing by <font color="#FB8C00"><b>${editSitebookLockOwner}</b></font>. You cannot save any changes at this time.`,
                    type: 'warning',
                    hideCancel: true,
                    confirmAction: function(){}
                });
            }

            // Check if they came here from alarms and want to edit a site
            if(!editSiteLockOwner && !editSitebookLockOwner && this.$store.state.editSiteFromAlarmShortcut) {
                this.editSite(this.$store.state.editSiteFromAlarmShortcut.alarm_site_id);
                this.$store.commit('setEditSiteFromAlarmShortcut', null);
            }
        });
    },

    destroyed() {
        this.$store.commit('setEditSiteFromAlarmShortcut', null);
    },

};
</script>

<style scoped>

    .data-container {
        display: block;
        padding: 0;
    }

</style>
